import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserContextService } from '@core/services';
import { BtnSize, BtnType } from '@shared/enums';
import { take } from 'rxjs';
import * as ProgramCodeConstants from '@core/constants/program-code-constants';

@Component({
  selector: 'sp-not-found',
  template: `
    <ng-container *ngIf="userContext$ | async as userContext">
      <sp-page-content-container>
        <div class="container">
          <div class="title">Hmm. We can't find that page.</div>
          <div class="no-tax-forms-svg">
            <img [src]="imageSrc" class="svg-content" />
          </div>
          <div class="button-container">
            <sp-button [btn]="btn.Primary" [btnSize]="size.Full" (onClick)="goToDashboard()"
              >Go to Dashboard</sp-button
            >
          </div>
        </div>
      </sp-page-content-container>
    </ng-container>
  `,
  styles: [
    `
      .container {
        padding: 1rem 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }
      .title {
        font-size: 2rem;
        padding-bottom: 2rem;
      }

      .button-container {
        padding-top: 2rem;
      }
    `,
  ],
})
export class PageNotFoundComponent implements OnInit {
  userContext$ = this.userContextService.userContext$;

  constructor(private router: Router, private userContextService: UserContextService) {}

  btn = BtnType;
  size = BtnSize;
  imageSrc = 'assets/errors/sure-404-error.svg';

  goToDashboard() {
    this.router.navigateByUrl('dashboard');
  }

  ngOnInit(): void {
    this.userContextService.userContext$.pipe(take(1)).subscribe(context => {
      const programCode = context.programCode.toLowerCase();
      if (
        ProgramCodeConstants.SurepayrollProgramCodeConstants.indexOf(programCode) >= 0 ||
        ProgramCodeConstants.RunpayrollProgramCodeConstants.indexOf(programCode) >= 0
      ) {
        this.imageSrc = `assets/errors/sure-404-error.svg`;
      } else if (ProgramCodeConstants.PaychexProgramCodeConstants.indexOf(programCode) >= 0) {
        this.imageSrc = `assets/errors/pxgo-404-error.svg`;
      } else if (ProgramCodeConstants.TruistProgramCodeConstants.indexOf(programCode) >= 0) {
        this.imageSrc = `assets/errors/sunt-404-error.svg`;
      }
    });
  }
}
